import React, { useEffect, useState } from "react";
import { Card, Select, Button, Text, Layout, Page } from "@shopify/polaris";
import { useLocation, useNavigate } from "react-router-dom";

const GoogleMerchantSelection = () => {
  const [selectedAccount, setSelectedAccount] = useState("");
  const [merchants, setMerchants] = useState([]);
  const location = useLocation();
  const navigate = useNavigate();

  //   const merchantAccounts = [];

  const handleSelectionChange = (value) => {
    setSelectedAccount(value);
  };

  const handleConfirm = async () => {
    try {
      const urlParams = new URLSearchParams(location.search);
      const paramValue = urlParams.get("shop");
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/google/merchants?shop=${paramValue}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ merchantId: selectedAccount }),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to update merchant ID");
      }
      const merchantRes = await response.json();
      if (merchantRes) {
        navigate(`/settings?shop=${paramValue}`);
      }
      if (!merchantRes) {
        console.error("Failed to parse response JSON", response);
        return;
      }
    } catch (error) {
      console.error("Error updating merchant ID:", error);
    }
  };

  useEffect(() => {
    let isMounted = true;

    const fetchMerchants = async () => {
      try {
        if (location.state && location.state.length > 0) {
          const merchantsArr = location.state.map((merchant) => ({
            label: merchant.merchantId,
            value: merchant.merchantId,
          }));

          if (isMounted) {
            setMerchants(merchantsArr);
            setSelectedAccount(merchantsArr[0]?.value);
          }
        } else {
          console.log("Location state", location);
          const urlParams = new URLSearchParams(location.search);
          const paramValue = urlParams.get("shop");

          const merchantsResponse = await fetch(
            `${process.env.REACT_APP_API_URL}/api/google/merchant/ids?shop=${paramValue}`
          );

          if (!merchantsResponse.ok)
            throw new Error("Failed to fetch merchants");

          const merchantRes = await merchantsResponse.json();
          console.log("Merhcant Response", merchantRes);
          const integrationInfo = merchantRes.data;

          if (integrationInfo) {
            const data = integrationInfo;
            if (data.accountIdentifiers && isMounted) {
              const merchantsArr = data.accountIdentifiers.map((merchant) => ({
                label: merchant.merchantId,
                value: merchant.merchantId,
              }));
              setMerchants(merchantsArr);
              setSelectedAccount(location.state.merchantId);

              const secondResponse = await fetch(
                `${process.env.REACT_APP_API_URL}/api/google/merchant/details?merchantId=${merchantsArr[0]?.value}`
              );

              if (!secondResponse.ok)
                throw new Error("Failed to fetch merchant details");

              const merchantDetails = await secondResponse.json();
              console.log("Merchant Details:", merchantDetails);
            }
          }
        }
      } catch (error) {
        console.error("Error fetching merchant data:", error);
      }
    };

    fetchMerchants();

    return () => {
      isMounted = false;
    };
  }, [location]);

  return (
    <Page>
      <Layout>
        <Layout.Section>
          {/* <Card sectioned>
            <Text variant="headingMd">
              Your shop is <strong>TESTUR11</strong> and your Google Account is{" "}
              <strong>hassantasleem@solcoders.com</strong>
            </Text>
          </Card> */}
          <Card sectioned>
            <Text variant="headingMd">
              Select Your Google Merchant Center Account
            </Text>
            <Text>
              You have successfully authenticated your Google account. Please
              select the Google Merchant Center account ID that you would like
              to use for submitting product data feed from your online store.
            </Text>
            <Select
              label="Google Merchant Center Account"
              options={merchants}
              onChange={handleSelectionChange}
              value={selectedAccount}
            />
            <br />
            <Button primary onClick={handleConfirm}>
              Confirm and Continue
            </Button>
          </Card>
        </Layout.Section>
      </Layout>
    </Page>
  );
};

export default GoogleMerchantSelection;
